import { useMemo, useState } from "react";
import { Colors } from "../../../utils/colors";
import { observer } from "mobx-react-lite";
import {
  useMatchDetailsStore,
  useMatchStatsStore,
} from "../../../stores/StoreContext";
import { UserAvatar } from "../../../components/userAvatar/UserAvatar";
import { MatchShotPatterns } from "./MatchShotPatterns";
import { MatchShotPatternsGraph } from "./MatchShotPatternsGraph";
import { MatchCourtCoverageGraph } from "./MatchCourtCoverageGraph";
import { CourtCoverageOptionsView } from "./CourtCoverageOptionsView";

export const ShotCoverageEnum = {
  SHOT_PATTERNS: "shotPatterns",
  COURT_COVERAGE: "courtCoverage",
};

export const ShotCoverageSection = observer(() => {
  const [selectedTab, setSelectedTab] = useState<string>("shotPatterns");
  const options = [
    { key: ShotCoverageEnum.SHOT_PATTERNS, label: "Shot Patterns" },
    { key: ShotCoverageEnum.COURT_COVERAGE, label: "Court Coverage" },
  ] as const;

  const shotGraph = useMemo(() => {
    if (selectedTab === ShotCoverageEnum.SHOT_PATTERNS) {
      return <MatchShotPatternsGraph />;
    } else {
      return <MatchCourtCoverageGraph />;
    }
  }, [selectedTab]);
  const matchStatsStore = useMatchStatsStore();

  return matchStatsStore.matchClutchStatsResponse.apiPlayerDetectedShots
    ?.length &&
    matchStatsStore.matchClutchStatsResponse.apiPlayerDetectedShots[0]
      .individualStats?.length ? (
    <div
      style={{
        paddingLeft: 15,
        paddingRight: 15,
        marginTop: 20,
        paddingTop: 30,
        paddingBottom: 30,
        backgroundColor: Colors.white,
        width: "100%",
        borderRadius: 20,
        marginBottom: 20,
      }}>
      <div
        style={{
          display: "flex",
          backgroundColor: Colors.lightGreyBackground,
          borderRadius: 10,
          position: "relative",
          width: "100%",
          margin: "0 auto",
          padding: 4,
        }}>
        {options.map((option) => (
          <button
            key={option.key}
            onClick={() => setSelectedTab(option.key)}
            style={{
              flex: 1,
              padding: "14px 0px",
              border: "none",
              borderRadius: 10,
              backgroundColor:
                selectedTab === option.key
                  ? Colors.white
                  : Colors.lightGreyBackground,
              color: selectedTab === option.key ? Colors.black : Colors.grey, // Light white for unselected
              fontSize: 14,
              fontWeight: 500,
              cursor: "pointer",
              transition: "all 0.2s ease",
              position: "relative",
              zIndex: selectedTab === option.key ? 2 : 1,
              minWidth: 80,
              textAlign: "center",
            }}>
            {option.label}
          </button>
        ))}
      </div>
      <MatchPlayers />

      {selectedTab === ShotCoverageEnum.COURT_COVERAGE ? (
        <CourtCoverageOptionsView />
      ) : (
        <MatchShotPatterns />
      )}
      {shotGraph}
    </div>
  ) : null;
});

export const MatchPlayers = observer(() => {
  const matchDetailsStore = useMatchDetailsStore();
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        width: "100%",
      }}>
      <div
        style={{
          flex: 1,
          marginLeft: 1,
          marginRight: 1,
          justifyContent: "center",
          alignItems: "center",
          gap: 20,
          display: "flex",
          flexDirection: "row",
          marginTop: 30,
          marginBottom: 20,
        }}>
        {matchDetailsStore.teamMates.map((teamMate) => (
          <UserAvatarWithOverlay
            size={48}
            name={teamMate.name}
            img={teamMate.userImageUrl}
            onPress={() => {
              matchDetailsStore.setClutchMatchCurrentPlayer(teamMate);
            }}
            disabled={
              matchDetailsStore.clutchMatchCurrentPlayer?.userId !==
              teamMate.userId
            }
          />
        ))}
      </div>
      <div
        style={{
          flex: 1,
          marginLeft: 1,
          marginRight: 1,
          justifyContent: "center",
          alignItems: "center",
          gap: 20,
          display: "flex",
          flexDirection: "row",
          marginTop: 30,
          marginBottom: 20,
        }}>
        {matchDetailsStore.opponents.map((opponent) => (
          <UserAvatarWithOverlay
            size={48}
            name={opponent.name}
            img={opponent.userImageUrl}
            onPress={() => {
              matchDetailsStore.setClutchMatchCurrentPlayer(opponent);
            }}
            disabled={
              matchDetailsStore.clutchMatchCurrentPlayer?.userId !==
              opponent.userId
            }
          />
        ))}
      </div>
    </div>
  );
});

export const UserAvatarWithOverlay = ({
  size,
  name,
  img,
  onPress,
  disabled,
}: {
  size: number;
  name?: string;
  img?: string;
  onPress?: () => void;
  disabled?: boolean;
}) => {
  return (
    <div
      onClick={onPress}
      style={{
        position: "relative",
      }}>
      <UserAvatar
        size={size}
        avatar={{
          image: img ?? "",
          name: name ?? "",
        }}
      />
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          backgroundColor: "white",
          width: size,
          height: size,
          borderRadius: size / 2,
          opacity: disabled ? 0.5 : 0,
        }}
      />
    </div>
  );
};
